import { SPORTS_PATHS } from "@shared-constants/routes";
import { EventoPage } from "@sports-features/event/event-page/event.page";
import { HomePage } from "@sports-features/home/home-page/home.page";
import { NowLiveDetailPage } from "@sports-features/live-market/live-market-page/live-market.page";
import { DirectosPage } from "@sports-features/live/live-page/live.page";
import { MercadosPage } from "@sports-features/market-page/market-page/market.page";
import { HorsesMarketPage } from "@sports-features/race-market/race-market-page/race-market.page";
import { HorsesPage } from "@sports-features/race/race-page/race.page";
import { SpecialTeamPage } from "@sports-features/special-team/special-team-page/special-team.page";
import { SportCountriesPage } from "@sports-features/sport-countries/sport-countries-page/sport-countries.page";
import { SportEventsPage } from "@sports-features/sport-events/sport-events-page/sport-events.page";
import { TodayPage } from "@sports-features/today/today-page/today.page";
import { CreaTuApuestaPage } from "@sports-pages/betbuilder/betbuilder.page";
import { CodereFantasyPage } from "@sports-pages/codere-fantasy/codere-fantasy.page";
import { MyBetsPage } from "@sports-pages/my-bets/my-bets-page/my-bets.page";
import {
  PARAMS,
  SPORTS_NAVIGATION_ERROR_TEXTS,
  SPORTS_NAVIGATION_SERVICE_ERROR_CODES,
} from "./sports.navigations.constants";

export const SPORTS_NAVIGATION_CONFIG = {
  // [SPORTS_PATHS.WhateverPagePath]: {
  //   PAGE: WhateverPage,
  //   PARAMS: Array of PARAMS,
  //   ERROR_CODE_BEHAVIOR: {
  //     [Whatever_error_from_ERROR_CODES]: {
  //       reload: boolean,
  //       back: boolean,
  //       redirectTo: boolean,
  //       onlyMessage: boolean,
  //       errorText: String,
  //     },
  //   },
  // },
  [SPORTS_PATHS.HomePage]: {
    PAGE: HomePage,
    PARAMS: null,
    ERROR_CODE_BEHAVIOR: {
      // No lo tratamos. Relanzamos polling tras 5 segundos en el effect
      // [SPORTS_NAVIGATION_SERVICE_ERROR_CODES.GENERIC_POLLING_ERROR]: {
      //   reload: false,
      //   back: false,
      //   redirectTo: null,
      //   onlyMessage: true,
      //   errorText: "Se ha detectado un problema en el servicio.",
      // },
    },
  },
  [SPORTS_PATHS.DirectosPage]: {
    PAGE: DirectosPage,
    PARAMS: null,
    ERROR_CODE_BEHAVIOR: {
      [SPORTS_NAVIGATION_SERVICE_ERROR_CODES.GENERIC_ERROR]: {
        reload: false,
        back: false,
        redirectTo: SPORTS_PATHS.HomePage,
        onlyMessage: false,
        errorText: SPORTS_NAVIGATION_ERROR_TEXTS.TEXT_0,
      },
      // [this.SPORTS_NAVIGATION_SERVICE_ERROR_CODES.EMPTY_DATA_ERROR]: {
      //   reload: false,
      //   back: false,
      //   redirectTo: SPORTS_PATHS.HomePage,
      //   errorText: SPORTS_NAVIGATION_ERROR_TEXTS.TEXT_0,
      // },
      [SPORTS_NAVIGATION_SERVICE_ERROR_CODES.GENERIC_POLLING_ERROR]: {
        reload: false,
        back: false,
        redirectTo: SPORTS_PATHS.HomePage,
        onlyMessage: false,
        errorText: SPORTS_NAVIGATION_ERROR_TEXTS.TEXT_0,
      },
    },
  },

  [SPORTS_PATHS.NowLiveDetailPage]: {
    PAGE: NowLiveDetailPage,
    PARAMS: [PARAMS.NODE_ID, PARAMS.SPORT_HANDLE, PARAMS.NAME],
    ERROR_CODE_BEHAVIOR: {
      [SPORTS_NAVIGATION_SERVICE_ERROR_CODES.GENERIC_POLLING_ERROR]: {
        reload: false,
        back: true,
        redirectTo: null,
        onlyMessage: false,
        errorText: SPORTS_NAVIGATION_ERROR_TEXTS.TEXT_1,
      },
    },
  },
  [SPORTS_PATHS.SportCountriesPage]: {
    PAGE: SportCountriesPage,
    PARAMS: [PARAMS.NODE_ID, PARAMS.NAME, PARAMS.SPORT_HANDLE],
    ERROR_CODE_BEHAVIOR: {
      [SPORTS_NAVIGATION_SERVICE_ERROR_CODES.GENERIC_ERROR]: {
        reload: false,
        back: true,
        redirectTo: null,
        onlyMessage: false,
        errorText: SPORTS_NAVIGATION_ERROR_TEXTS.TEXT_0,
      },
    },
  },
  [SPORTS_PATHS.EventoPage]: {
    PAGE: EventoPage,
    PARAMS: [PARAMS.NAME, PARAMS.NODE_ID, PARAMS.SPORT_HANDLE],
    ERROR_CODE_BEHAVIOR: {
      [SPORTS_NAVIGATION_SERVICE_ERROR_CODES.GENERIC_ERROR]: {
        reload: false,
        back: false,
        redirectTo: SPORTS_PATHS.HomePage,
        onlyMessage: false,
        errorText: SPORTS_NAVIGATION_ERROR_TEXTS.TEXT_0,
      },
    },
  },
  [SPORTS_PATHS.MercadosPage]: {
    PAGE: MercadosPage,
    PARAMS: [
      PARAMS.NAME,
      PARAMS.NODE_ID,
      PARAMS.SPORT_HANDLE,
      PARAMS.LEAGUE_NAME,
      PARAMS.START_DATE,
      PARAMS.SPORT_NAME,
    ],
    ERROR_CODE_BEHAVIOR: {
      [SPORTS_NAVIGATION_SERVICE_ERROR_CODES.GENERIC_ERROR]: {
        reload: false,
        back: false,
        redirectTo: SPORTS_PATHS.HomePage,
        onlyMessage: false,
        errorText: SPORTS_NAVIGATION_ERROR_TEXTS.TEXT_2,
      },
    },
  },
  [SPORTS_PATHS.TodayPage]: {
    PAGE: TodayPage,
    PARAMS: null,
    ERROR_CODE_BEHAVIOR: {
      [SPORTS_NAVIGATION_SERVICE_ERROR_CODES.GENERIC_ERROR]: {
        reload: false,
        back: false,
        redirectTo: SPORTS_PATHS.HomePage,
        onlyMessage: false,
        errorText: SPORTS_NAVIGATION_ERROR_TEXTS.TEXT_2,
      },
      [SPORTS_NAVIGATION_SERVICE_ERROR_CODES.GENERIC_POLLING_ERROR]: {
        reload: false,
        back: false,
        redirectTo: false,
        onlyMessage: true,
        errorText: SPORTS_NAVIGATION_ERROR_TEXTS.TEXT_2,
      },
    },
  },
  [SPORTS_PATHS.HorsesPage]: {
    PAGE: HorsesPage,
    PARAMS: [PARAMS.SPORT_HANDLE],
    ERROR_CODE_BEHAVIOR: {
      [SPORTS_NAVIGATION_SERVICE_ERROR_CODES.GENERIC_ERROR]: {
        reload: false,
        back: false,
        redirectTo: SPORTS_PATHS.HomePage,
        onlyMessage: false,

        errorText: SPORTS_NAVIGATION_ERROR_TEXTS.TEXT_3,
      },
    },
  },
  [SPORTS_PATHS.HorsesMarketPage]: {
    PAGE: HorsesMarketPage,
    PARAMS: [PARAMS.SPORT_HANDLE, PARAMS.NODE_ID],
    ERROR_CODE_BEHAVIOR: {
      [SPORTS_NAVIGATION_SERVICE_ERROR_CODES.GENERIC_ERROR]: {
        reload: false,
        back: true,
        redirectTo: null,
        onlyMessage: false,
        errorText: SPORTS_NAVIGATION_ERROR_TEXTS.TEXT_3,
      },
      [SPORTS_NAVIGATION_SERVICE_ERROR_CODES.EMPTY_DATA_ERROR]: {
        reload: false,
        back: true,
        redirectTo: null,
        onlyMessage: false,
        errorText: SPORTS_NAVIGATION_ERROR_TEXTS.TEXT_3,
      },
      [SPORTS_NAVIGATION_SERVICE_ERROR_CODES.EMPTY_DATA_WARNING_ERROR]: {
        reload: false,
        back: false,
        redirectTo: null,
        onlyMessage: true,
        errorText: SPORTS_NAVIGATION_ERROR_TEXTS.TEXT_4,
      },
      [SPORTS_NAVIGATION_SERVICE_ERROR_CODES.GENERIC_POLLING_ERROR]: {
        reload: false,
        back: true,
        redirectTo: null,
        onlyMessage: false,
        errorText: SPORTS_NAVIGATION_ERROR_TEXTS.TEXT_3,
      },
    },
  },
  [SPORTS_PATHS.MisApuestasPage]: {
    PAGE: MyBetsPage,
    PARAMS: null,
  },
  [SPORTS_PATHS.SportEventsPage]: {
    PAGE: SportEventsPage,
    PARAMS: [PARAMS.SPORT_HANDLE, PARAMS.NAME],
  },
  [SPORTS_PATHS.CreaTuApuestaPage]: {
    PAGE: CreaTuApuestaPage,
    PARAMS: null,
  },
  [SPORTS_PATHS.CodereFantasy]: {
    PAGE: CodereFantasyPage,
    PARAMS: null,
  },
  [SPORTS_PATHS.SpecialTeamPage]: {
    PAGE: SpecialTeamPage,
    PARAMS: [PARAMS.TEAM],
  },
};
